export default {
  loading: false,
  data: null,
  currentPage: 1,
  take: 30,
  viewOrderRows: [],
  orderRows: {},
  loadingRows: false
}